import { render } from "./NdptKR.vue?vue&type=template&id=56f29b1c"
import script from "./NdptKR.vue?vue&type=script&lang=js"
export * from "./NdptKR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__